import { FIELD_TYPE } from "types/enums";
import { DataFormField } from "types/models/input-field-type";
const { INPUT, SELECT, DATE, COLOR } = FIELD_TYPE;
const css1 = {
  wrapperCol: {
    span: 22,
  },
  labelCol: {
    span: 2,
  },
  css: {
    xl: 2,
  },
};
const css2 = {
  wrapperCol: {
    span: 20,
  },
  labelCol: {
    span: 4,
  },
  css: {
    xl: 11,
  },
};
const dataFields: DataFormField[] = [
  {
    type: INPUT,
    label: "ID",
    name: "id",
    disable: true,
    ...css1,
  },
  {
    type: INPUT,
    label: "Tên thuốc",
    name: "tenThuocTra",
    rules: [{ required: true, message: "Chưa nhập tên thuốc" }],
    ...css2,
  },
  {
    type: INPUT,
    label: "Tên viết tắt",
    name: "tenVietTat",
    ...css2,
    rules: [{ required: true, message: "Chưa nhập tên viết tắt" }],
  },
];

const dataFieldsLD: DataFormField[] = [
  {
    type: INPUT,
    label: "ID",
    name: "id",
    disable: true,
    ...css1,
  },
  {
    type: SELECT,
    label: "Kiểu",
    name: "type",
    rules: [{ required: true, message: "Chưa nhập kiểu" }],
    options: [
      {
        value: 0,
        label: "Lệ đạo trên",
      },
      {
        value: 1,
        label: "Lệ đạo dưới",
      },
    ],
    ...css2,
  },
  {
    type: INPUT,
    label: "Tên lệ đạo",
    name: "tenLeDao",
    rules: [{ required: true, message: "Chưa nhập tên lệ đạo" }],
    ...css2,
  },
];

const dataFieldsNA: DataFormField[] = [
  {
    type: INPUT,
    label: "ID",
    name: "id",
    disable: true,
    ...css1,
  },
  {
    type: INPUT,
    label: "Giá trị hiển thị in",
    name: "value",
    rules: [{ required: true, message: "Chưa nhập giá trị" }],
    ...css2,
  },
  {
    type: INPUT,
    label: "Tên nhãn áp",
    name: "tenNhanAp",
    rules: [{ required: true, message: "Chưa nhập tên nhãn áp" }],
    ...css2,
  },
];
export { dataFields, dataFieldsLD, dataFieldsNA };
